import { Card, Column, Row } from "@components/Layout";
import { styled } from "solid-styled-components";

export const CommentsWrapperCard = styled(Card)`
  overflow: auto;
  position: relative;
`;

export const HeaderRow = styled(Row)`
  background: ${({ theme }) => theme?.colors.foreground};
  position: sticky;
  top: 0;
`;

export const AddCommentRow = styled(HeaderRow)`
  bottom: 0;
  top: unset;
`;

export const CommentsColumn = styled(Column)`
  min-height: 100%;
`;
